export class CortesCachosFactory {
  constructor(instance) {
    this.instance = instance;
  }

  getSaldo(filter) {
    return this.instance.get('/v1/cortes-cachos/saldo', {
      params: filter || null,
    });
  }

  getDashboard(filter) {
    return this.instance.get('/v1/cortes-cachos/dashboard', {
      params: filter || null,
    });
  }

  listColheita(filter) {
    return this.instance.get('/v1/cortes-cachos/colheita', {
      params: filter || null,
    });
  }

  listDescarte(filter) {
    return this.instance.get('/v1/cortes-cachos/descarte', {
      params: filter || null,
    });
  }
}

export default (...params) => new CortesCachosFactory(...params);
